export const URL_IMAGES = `http://ec2-54-234-62-6.compute-1.amazonaws.com:8080/public/images/`

export const URL_IMAGES_REX = `${ URL_IMAGES }t-rex/`

export const URL_IMAGEs_BRAND = `${ URL_IMAGES }brand/`